module.exports = __webpack_public_path__ + "static/media/bank deposit.dbd9a41b.svg";